import { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';



import { LangPopup } from '@shared';
import { PrologueStage, useAvailableQuestsIsLanguageSelection, usePrologue } from '@store';


export const ProtectedRoute = ({ children }: PropsWithChildren) => {
  const location = useLocation()
  const prologueStage = usePrologue.store.prologueStage()
  const isLanguageSelection = useAvailableQuestsIsLanguageSelection()

  // TODO: пока что не удаляем тестим 
  // if (!isLanguageSelection) {
  //   return <LangPopup />
  // }

  if (
    prologueStage === PrologueStage.BeforeSpiral &&
    location.pathname !== '/prologue'
  ) {
    return <Navigate to="/prologue" replace />
  }

  return <>{children}</>
}
